
import Inputmask from "inputmask";

// Process
var Process = function () {

    var Load = function () {

        // posta kodu sınırlama
        const postalCodeInput = document.querySelector('*[name="shipping_postal_code"], *[name="postal_code"], *[name="invoice_postal_code"]');
        if (postalCodeInput) {
            Inputmask({
                // autoUnmask: true,
                casing: 'upper',
                mask: 'A9A 9A9',
                definitions: {
                    'A': {
                        validator: '[A-Za-z]',
                    },
                    '9': {
                        validator: '[0-9]',
                    },
                },
            }).mask(postalCodeInput);
        }

    }

    return {
        init: function () {
            Load();
        },
    };

}();

$(function () {

    Process.init();

});